import React from 'react';
import TableProjectComponent from './table-project.component';

function TableProject(props) {
    return <TableProjectComponent {...props} />;
}

export default TableProject;
